const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "Submitting a near-expiry passport",
    desc: "Many countries require 6 months of validity beyond your travel dates. A 4-month-valid passport will be denied at customs — we flag this before submission.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Incorrect or missing supporting documents",
    desc: "Citizenship evidence, name change documents, parental consent forms — missing any one of these causes rejection. We provide a complete checklist for Lee's Summit applicants.",
  },
  {
    icon: "ri-camera-off-line",
    title: "Non-compliant passport photos",
    desc: "Selfies, smiling photos, and wrong background colors are the most common rejection cause. We guide you to compliant photos before submission.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Paying courier markup",
    desc: "FedEx, Staples, and AAA resell our same courier service at 30–100% markup. As a direct State Department courier, we have a best price guarantee.",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Waiting too long for routine processing",
    desc: "If you wait for 6–8 week routine processing and your trip is in 4 weeks, you'll be stuck. Act when your passport is within 6 months of expiry or your trip is within 10 weeks.",
  },
];

export default function LeeSummitMistakesSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            5 Passport Mistakes Lee&apos;s Summit Travelers Make
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes cost time, money, and trips. Our professional document review catches every one of these before your application is submitted.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}